import type { RouteRecordRaw } from "vue-router";

import auth from "./auth/index.ts";
import { cycleCountRoutes } from "./cycleCount/index.ts";
import reportUploader, { reportUploaderMenu } from "./reportUploader.ts";
import { usersMenu, users } from "./users/index.ts";

import { brands } from "@/router/brands/index.ts";
import { catalogMenu } from "@/router/catalog/index.ts";
import channels from "@/router/channels/index.ts";
import competitors from "@/router/competitors/index.js";
import { deliveryRoutes } from "@/router/delivery/index.ts";
import {
  enforcementMenu,
  enforcementRoutes,
} from "@/router/enforcement/index.ts";
import forecastMenu from "@/router/forecast/index.ts";
import { outboundRoutes } from "@/router/outbound/index.ts";
import { preparationRoutes } from "@/router/preparation/index.ts";
import products from "@/router/products/index.ts";
import { retailers } from "@/router/retailers/index.js";
import seasonalityEventsMenu from "@/router/seasonalityEvents/index.ts";
import settings from "@/router/settings/index.ts";
import { tiktokMenu, tiktok } from "@/router/tiktok/index.ts";
import { warehouseMenu } from "@/router/warehouse/index.js";
import { parseEnvBoolean } from "@/utils/env/parse-boolean.ts";

const isTiktokEnabled = parseEnvBoolean(import.meta.env.VITE_TIKTOK_API_ENABLED);

const modules: Array<RouteRecordRaw> = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/not-found",
  },
  {
    path: "/",
    redirect: "/products",
  },
  {
    path: "/not-found",
    name: "not-found",
    component: () => import("@/views/NotFound.vue"),
  },

  ...auth,
  ...products,
  ...settings,
  ...brands,
  ...deliveryRoutes,
  ...preparationRoutes,
  ...users,
  ...usersMenu,
  ...reportUploader,
  ...enforcementMenu,
  ...reportUploaderMenu,
  ...enforcementRoutes,
  ...cycleCountRoutes,
  ...forecastMenu,
  ...outboundRoutes,
  ...(isTiktokEnabled ? tiktok : []),
  ...channels,
  ...warehouseMenu,
  ...competitors,
  ...retailers,
  ...seasonalityEventsMenu,
];

export const routesForMenu = [
  ...catalogMenu,
  ...competitors,
  ...forecastMenu,
  ...warehouseMenu,
  ...enforcementMenu,
  ...(isTiktokEnabled ? tiktokMenu : []),
  ...reportUploaderMenu,
  ...settings,
  ...seasonalityEventsMenu,
  ...usersMenu,
];

export default modules;
